<template>
  <el-button v-bind="$attrs" v-on="innerListens" :loading="isLoading">
    <slot></slot>
  </el-button>
</template>

<script>
import { asyncThrottle } from '@/utils/utils';
export default {
  props: {
    loadingMode: {
      type: String,
      default: 'button', // global|button|'' 默认按钮loading
    },
    // loadingMode === 'global' 时有效
    loadingText: {
      type: String,
      default: '处理中，请稍后...',
    },
  },
  // 额外提供外部自定义loading能力
  // emits: ['loadingStart', 'loadingEnd'],
  data() {
    return {
      innerListens: {},
      isLoading: false,
    };
  },
  methods: {
    fnLoadingAsync(asyncFn) {
      const vm = this;
      return async function (...args) {
        /** 1. 开始loading */
        let loadingObj = {};
        if (vm.loadingMode === 'button') {
          vm.isLoading = true;
        } else if (vm.loadingMode === 'global') {
          loadingObj = vm.$loading({ text: vm.loadingText });
        }
        vm.$emit('loadingStart');

        // 2. 劫持内部处理函数
        await asyncFn.apply(this, args);

        // 3. 结束loading
        vm.isLoading = false;
        loadingObj.close?.();
        vm.$emit('loadingEnd');
      };
    },
  },
  created() {
    const newListens = { ...this.$listeners };
    console.log(newListens);
    if (newListens.click) {
      newListens.click = this.fnLoadingAsync(asyncThrottle(newListens.click));
    }
    this.innerListens = newListens;
  },
};
</script>
